import { SWRConfiguration } from 'swr';

import { PendingScheduleChanges } from '~/features/ScheduledEmploymentChanges/ScheduleChanges/useScheduleChanges';
import { UseArraySWROutput, useArraySWR } from '~/hooks/useSWR';
import { fetchFromOldApi } from '~/services/Http';

export const PENDING_SCHEDULE_CHANGES_SWR_KEY = 'schedulePendingEmployment';

export const getPendingData = async (empId: number) =>
  await fetchFromOldApi(`/json/employee/${empId}/scheduledemployment`).then<
    PendingScheduleChanges[]
  >((r) => r.json());

export const useSchedulePendingEmployment = (
  employeeId: number,
  swrConfig?: SWRConfiguration,
): UseArraySWROutput<PendingScheduleChanges> => {
  return useArraySWR(
    [PENDING_SCHEDULE_CHANGES_SWR_KEY, employeeId],
    ([_key, employeeId]) => getPendingData(employeeId),
    { revalidateOnFocus: false, ...swrConfig },
  );
};
